import { axiosInstance } from "../api/client";

export const fetchCurrentUser = async () =>
  axiosInstance.get("/current-user/me").then((response) => response.data);
